import { useHeaderHeight } from "@react-navigation/elements";
import {
  KeyboardAvoidingView,
  Platform,
  StyleProp,
  ViewStyle,
} from "react-native";
import { useTailwind } from "tailwind-rn";

type Props = {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
};

export default function KeyboardAwareView({ children, style }: Props) {
  const tailwind = useTailwind();
  const headerHeight = useHeaderHeight();
  //android seems to need an extension of 25 to avoid the keyboard hiding the input field
  const offset = Platform.OS === "ios" ? headerHeight : headerHeight + 25;
  return (
    <KeyboardAvoidingView
      behavior="padding"
      style={[tailwind("flex-1 relative"), style]}
      keyboardVerticalOffset={offset}
    >
      {children}
    </KeyboardAvoidingView>
  );
}
